import React, { useState,useEffect} from 'react';
import NavBar from "./Components/NavBar/NavBar";
import { Switch, Route } from "react-router-dom";
import Zoom from 'react-reveal/Zoom';
import Logo from './Capture.JPG';
import Home from "./Components/Home/Home";
import About from "./Components/About/About";
import Projects from './Components/Projects/Projects';
import Contact from './Components/Contact/Contact';

import "./App.css";

function App() {

const[loading,setLoading] = useState(true);

  useEffect(()=>{
    setTimeout(()=>{
      setLoading(false)
    },2000)
  },[])

  return (
    <div className="App">
     {
       loading ?  
       <div className="app__loader">         
           <Zoom>
             <div className="app__loaderImageParent">
               <img className="app__loaderImage" src={Logo} alt=""/>
             </div>
           </Zoom>          
       </div>
       :
       <>
      <div>
        <NavBar />
      </div>

      <div>
        <Switch>
          <Route path="/" exact={true} component={Home} />
          <Route path="/about" component={About} />
          <Route path="/projects" component={Projects}/>
          <Route path="/contact" component={Contact} />
        </Switch>
      </div>
      </>
    }
    </div>
  );
}

export default App;
